import { render, staticRenderFns } from "./pop-set-certificate.vue?vue&type=template&id=3d538449&scoped=true"
import script from "./pop-set-certificate.vue?vue&type=script&lang=js"
export * from "./pop-set-certificate.vue?vue&type=script&lang=js"
import style0 from "./pop-set-certificate.vue?vue&type=style&index=0&id=3d538449&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d538449",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d538449')) {
      api.createRecord('3d538449', component.options)
    } else {
      api.reload('3d538449', component.options)
    }
    module.hot.accept("./pop-set-certificate.vue?vue&type=template&id=3d538449&scoped=true", function () {
      api.rerender('3d538449', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/certificate/components/pop-set-certificate.vue"
export default component.exports